<template>
  <v-chart :option="option" :autoresize="true"/>
</template>

<script>

  import { use } from 'echarts/core';
  import { CanvasRenderer } from 'echarts/renderers';
  import { PieChart } from 'echarts/charts';

  import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
  } from 'echarts/components';

  import VChart, { THEME_KEY } from 'vue-echarts';

  use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
  ]);


  export default {
    props: {
      chartData: {
        type: Array
      }
    },
    computed: {
      goalValue() {
        if (!this.chartData)    return 0;
        if (!this.chartData[1]) return 0;

        return this.chartData[1].value || 0;
      },
      realizedValue() {
        if (!this.chartData)    return 0;
        if (!this.chartData[0]) return 0;

        return this.chartData[0].value || 0;
      },
      pendingValue() {
        const value = this.goalValue - this.realizedValue;

        if (value < 0) return 0;

        return value;
      },
      percentage() {
        if (this.goalValue === 0)     return 0;
        if (this.realizedValue === 0) return 0;

        return Math.round(100 * this.realizedValue / this.goalValue);
      },
      pendingPercentage() {
        if (this.goalValue === 0)     return 0;
        if (this.pendingValue === 0)  return 100;

        return Math.round(100 * this.pendingValue / this.goalValue);
      },
      percentageText() {
        return this.percentage.toLocaleString('pt-BR') + '%';
      },
      pendingPercentageText() {
        return this.pendingPercentage.toLocaleString('pt-BR') + '%';
      },
      option() {
        const percentage = this.percentage;
        const percentageText = this.percentageText
        const pendingPercentageText = this.pendingPercentageText

        return {
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              type: 'pie',
              radius: ['30%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
              },
              data: [
                (this.percentage > 0 ? {
                  value: this.realizedValue,
                  itemStyle: {
                    color: '#2dce89'
                  },
                  label: this.chartData[0].label,
                  name: this.chartData[0].label,
                  tooltip: {
                    valueFormatter: (value) => `(${percentageText}) ${value.toLocaleString("pt-BR", {style: "currency", currency: "brl"})}`
                  },
                } : null),
                (this.goalValue || this.percentage === 0 ? {
                  itemStyle: {
                    color: '#ffc107'
                  },
                  value: this.pendingValue,
                  label: "Meta não realizada",
                  name: "Meta não realizada",
                  tooltip: {
                    valueFormatter: (value) => `(${pendingPercentageText}) ${value.toLocaleString("pt-BR", {style: "currency", currency: "brl"})}`
                  }
                } : null),
              ]
            },
            {
              type: 'pie',
              silent: true,
              data: [
                {
                  // Adicione um item fictício para exibir a porcentagem no centro
                  value: percentage, // Você pode ajustar o valor conforme necessário
                  groupID: 'hidden',
                  name: 'Porcentagem Total',
                  itemStyle: {
                    color: 'transparent', // Define a cor como transparente para que não apareça na legenda
                  },
                  label: {
                    show: true,
                    position: 'center', // Define a posição como 'center' para o rótulo no centro
                    fontSize: 10,
                    formatter() {
                      return percentageText
                    }
                  },
                  tooltip: {
                    valueFormatter: () => percentageText
                  },
                }
              ]
            }
          ]
        }
      }
    }
  }
</script>
<style scoped>
  .chart {
    height: 100%;
    width: 100%;
  }
</style>
